"use client";

import { c as _c } from "react/compiler-runtime";
import { breakpointMin, TABLET_BREAKPOINT } from "@/lib/breakpoints";
import { useSyncExternalStore } from "react";
const LANDSCAPE_MQ = "(orientation: landscape)";
const TOUCH_MQ = "(any-pointer: coarse), (hover: none), (pointer: coarse)";
/** Phones only — iPad mini portrait is 768px, so use strict < 768. */
const PHONE_MAX_SHORTEST_SIDE = TABLET_BREAKPOINT - 1;
/** Largest phone landscape width (~932px); excludes wide desktop/DevTools viewports. */
const PHONE_MAX_LONGEST_SIDE = breakpointMin.tabletLg;
function getWindow() {
  return globalThis.window;
}
function isIPad() {
  return /iPad/i.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
function isPhoneSizedViewport() {
  const win = getWindow();
  if (!win) return false;
  const shortestSide = Math.min(win.innerWidth, win.innerHeight);
  const longestSide = Math.max(win.innerWidth, win.innerHeight);
  if (shortestSide <= 0 || longestSide <= 0) return false;
  return shortestSide < PHONE_MAX_SHORTEST_SIDE && longestSide < PHONE_MAX_LONGEST_SIDE;
}
function isMobileDevice() {
  const win = getWindow();
  if (!win || isIPad() || !win.matchMedia(TOUCH_MQ).matches) return false;
  return isPhoneSizedViewport();
}
function isLandscape() {
  const win = getWindow();
  if (!win) return false;
  return screen.orientation?.type?.startsWith("landscape") ?? win.matchMedia(LANDSCAPE_MQ).matches;
}
function isLandscapeOnMobile() {
  return isMobileDevice() && isLandscape();
}
function addListener(target: EventTarget, event: string, handler: () => void) {
  target.addEventListener(event, handler);
  return () => target.removeEventListener(event, handler);
}
function subscribe(onStoreChange: () => void) {
  const win = getWindow();
  if (!win) return () => undefined;
  const onChange = () => onStoreChange();
  const cleanups = [addListener(win.matchMedia(LANDSCAPE_MQ), "change", onChange), addListener(win.matchMedia(TOUCH_MQ), "change", onChange), addListener(win, "resize", onChange), addListener(win, "orientationchange", onChange), screen.orientation && addListener(screen.orientation, "change", onChange)].filter(Boolean);
  return () => cleanups.forEach(cleanup => cleanup());
}
export function useOrientation() {
  const $ = _c(2);
  const showOverlay = useSyncExternalStore(subscribe, isLandscapeOnMobile, _temp);
  let t0;
  if ($[0] !== showOverlay) {
    t0 = {
      showOverlay
    };
    $[0] = showOverlay;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp() {
  return false;
}